import {useState, useEffect, useMemo} from 'react';
// import {useSelector} from 'react-redux';
import { localizeIndustryList, localizeProfileList, t } from '../../content';
import { useLocale } from '../../locale';
import { findIndustryBySelectValue, findProfileBySelectValue } from '../../Utilities';

import ExplanationTooltip from '../reusableElementsComponents/ExplanationTooltip';
import {Select, Text, TextArea} from '../formComponents/Inputs';
import B2BApiService from "../../B2bApiService";
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


function NewPositionGeneral({data, updateData, formValidate}) {
    const { locale } = useLocale();

    let [jobIndustries, setJobIndustries] = useState([]);
    let [selectedJobProfiles, setSelectedJobProfiles] = useState([]);
    const departmentOptions = useMemo(
        () => localizeIndustryList(jobIndustries, locale),
        [jobIndustries, locale]
    );
    const profileOptions = useMemo(
        () => localizeProfileList(selectedJobProfiles, locale),
        [selectedJobProfiles, locale]
    );
    const [deadline, setDeadline] = useState(data.deadline);
    const [selectedTargetProfile, setSelectedTargetProfile] = useState(data.target_profile_id || '');
    const [selectedDepartment, setSelectedDepartment] = useState(data?.industry_id);
    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    useEffect(() => {
        b2bServiceObj.LoadIndustriesList(setJobIndustries);
    }, [b2bServiceObj]);

    const handleTitleChange = (e) => {
        data['title'] = e.target.value
        updateData({...data, 'title': e.target.value});
    }

    const handleDescriptionChange = (e) => {
        data['description'] = e.target.value
        updateData({...data, 'description': e.target.value});
    }

    const handleSelectIndustry = (e) => {
        const match = findIndustryBySelectValue(jobIndustries, e.target.value);
        if (!match) {
            return;
        }
        setSelectedDepartment(match.id);
        setSelectedTargetProfile('');
        setSelectedJobProfiles([]);
        data['industry_id'] = match.id.toString();
        data['target_profile_id'] = '';
        updateData({...data, industry_id: match.id.toString(), target_profile_id: ''});
        b2bServiceObj.LoadTargetProfilesByIndustry(match, setSelectedJobProfiles);
    }

    const handleSelectTargetProfile = (e) => {
        const match = findProfileBySelectValue(profileOptions, e.target.value);
        if (!match) {
            return;
        }
        setSelectedTargetProfile(String(match.id));
        handleChange(match.id.toString(), 'target_profile_id');
    }

    const handleDateChange = (date) => {
        setDeadline(date);
        updateData({...data, 'deadline': date});
    }

    const handleChange = (value, key) => {
        data[key] = value
        updateData({...data, [key]: value});
    }

    return (
        <>
            <div className="titleSection section">
                <div className="title">
                    <div className="field-label">{t('recruitment.form.positionName')}</div>
                    <Text
                        title=""
                        required={true}
                        fullWidth={true}
                        doValidation={formValidate}
                        errorContent={t('recruitment.form.positionTitleError')}
                        handleChange={handleTitleChange}
                    />
                </div>

                <div className="date">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="field-label">{t('recruitment.form.deadline')}</div>
                        <DatePicker
                            label=""
                            value={deadline}
                            onChange={date =>  handleDateChange(date)}
                            renderInput={(params) => <TextField {...params} />}
                        />
                    </LocalizationProvider>
                </div>
            </div>

            <div className="departmentSection section">
                <div className="department">
                    <div className="field-label">{t('recruitment.form.department')}</div>
                    {jobIndustries.length > 0 &&
                    <Select
                        id={'industry_id'}
                        label={t('recruitment.form.department')}
                        options={departmentOptions}
                        doValidation={formValidate}
                        errorContent={t('validation.selectDepartment')}
                        handleChange={handleSelectIndustry}
                        option={selectedDepartment ? selectedDepartment : ''}
                    />
                    }
                </div>
                { selectedDepartment &&
                   <div className="targetProfile">
                       <div className="field-label">
                           {t('recruitment.form.targetProfile')}
                           <ExplanationTooltip>
                               <p>{t('recruitment.form.targetProfileExplanation')}</p>
                           </ExplanationTooltip>
                       </div>
                   <Select
                       id={'target_profile'}
                       label={t('recruitment.form.targetProfile')}
                       options={profileOptions}
                       doValidation={formValidate}
                       errorContent={t('recruitment.form.targetProfileError')}
                       handleChange={handleSelectTargetProfile}
                       option={selectedTargetProfile ? selectedTargetProfile : ''}
                   />
                    </div>
                }
            </div>

            <br/>
            <div className="description">
                <div className="field-label">{t('recruitment.form.jobDescription')} (<span className="italic"> {t('recruitment.form.visibleToCandidate')}. </span>)</div>
                <TextArea
                    title=""
                    required={false}
                    fullWidth={true}
                    handleChange={handleDescriptionChange}
                />
            </div>
        </>
    )
}

export default NewPositionGeneral






